import React from "react";

import { useDispatch, useSelector } from "react-redux";

import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";

import {
  ANNOUNCEMENT_CREATE_REQUESTED,
  ANNOUNCEMENT_DELETE_REQUESTED,
  ANNOUNCEMENT_GET_ALL_REQUESTED,
  ANNOUNCEMENT_UPDATE_REQUESTED,
} from "../../../redux/actions";
import ReactGA from "react-ga4";
import styles from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";

import AddAnnouncement from "./addUpdateAndAnnouncement";
import UpdateAnnouncement from "./updateUpdateAndAnnouncement";

import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Slide,
  Typography,
} from "@material-ui/core";
import UpdateCard from "./updatesCard";
import GridItem from "components/Grid/GridItem";
import Close from "@material-ui/icons/Close";
import CustomPagination from "components/CustomPagination/CustomPagination";
import { useGetAnnouncements } from "api/announcement";
import useUrlParams from "utils/urlParms";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
const useStyles = makeStyles(styles);

export default function Announcement() {
  const [addAnnouncementModal, setAddAnnouncementModal] = React.useState(false);
  const [editAnnouncementModal, setEditAnnouncementModal] =
    React.useState(false);
  const [announcementId, setAnnouncementId] = React.useState(null);

  const dispatch = useDispatch();

  const { data, isLoading: announcementsFetching } = useGetAnnouncements();
  console.log(data);
  const { setUrlParams, getUrlParams } = useUrlParams();

  const announcementList = data?.rows || [];
  const announcementDeleteSuccess = useSelector(
    (state) => state.announcement.announcementDeleteSuccess
  );
  const announcementDeleteFetching = useSelector(
    (state) => state.announcement.announcementDeleteFetching
  );
  const announcementDeleteError = useSelector(
    (state) => state.announcement.announcementDeleteError
  );

  const classes = useStyles();

  const handleCreate = (payload) => {
    dispatch({
      type: ANNOUNCEMENT_CREATE_REQUESTED,
      payload: payload,
    });
  };

  const handleUpdate = (payload) => {
    const { id, ...rest } = payload;
    dispatch({
      type: ANNOUNCEMENT_UPDATE_REQUESTED,
      payload: { id, payload: rest },
    });
  };

  const handleDelete = (payload) => {
    dispatch({
      type: ANNOUNCEMENT_DELETE_REQUESTED,
      payload: payload,
    });
  };
  React.useEffect(() => {
    if (announcementDeleteSuccess) {
      dispatch({ type: ANNOUNCEMENT_GET_ALL_REQUESTED });
    }
  }, [announcementDeleteSuccess]);
  return (
    <>
      {/*Add Announcement*/}
      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper:   " " + classes.modalMediumXL,
        }}
        open={addAnnouncementModal}
        TransitionComponent={Transition}
        disableScrollLock={true}
        onClose={(event, reason) => {
          if (reason === "backdropClick") {
            return false;
          }

          if (reason === "escapeKeyDown") {
            return false;
          }
          setAddAnnouncementModal(false);
        }}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => setAddAnnouncementModal(false)}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h3 className={classes.modalTitle}>New Announcement</h3>
        </DialogTitle>
        <DialogContent
          id="classic-modal-slide-description"
          className={classes.modalBody}
        >
          <AddAnnouncement handleCreate={handleCreate} />
        </DialogContent>
      </Dialog>

      {/*Edit Announcement*/}
      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper:   " " + classes.modalMediumXL,
        }}
        open={editAnnouncementModal}
        TransitionComponent={Transition}
        disableScrollLock={true}
        onClose={(event, reason) => {
          if (reason === "backdropClick") {
            return false;
          }

          if (reason === "escapeKeyDown") {
            return false;
          }
          setEditAnnouncementModal(false);
        }}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => setEditAnnouncementModal(false)}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h3 className={classes.modalTitle}>Edit Announcement</h3>
        </DialogTitle>
        <DialogContent
          id="classic-modal-slide-description"
          className={classes.modalBody}
        >
          <UpdateAnnouncement
            announcementId={announcementId}
            handleUpdate={handleUpdate}
          />
        </DialogContent>
      </Dialog>
      <Box
        sx={{
          width: "90%",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          margin: "20px auto",
        }}
      >
        <Box height="80vh" overflow="scroll">
          <GridContainer justifyContent="space-between" gap="4" direction="row">
            <GridItem xs="8">
              <Typography variant="h4" component="div" sx={{ marginBottom: 3 }}>
                Updates and Announcements
              </Typography>
            </GridItem>

            <GridItem xs="4" justifyContent="flex-end">
              <Button
                onClick={() => {
                  setAddAnnouncementModal(true);
                }}
                color="primary"
              >
                Add Announcement
              </Button>
            </GridItem>
          </GridContainer>
          <GridContainer gap={2} flex={1}>
            {announcementList.map((update, index) => (
              <GridItem xs={12} sm={6} key={index}>
                <UpdateCard
                  setAnnouncementId={setAnnouncementId}
                  setEditAnnouncementModal={setEditAnnouncementModal}
                  handleDelete={handleDelete}
                  {...update}
                />
              </GridItem>
            ))}
          </GridContainer>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: 3,
          }}
        >
          {/* <Pagination count={10} variant="outlined" shape="rounded" /> */}
          <CustomPagination totalItems={data?.count} defaultPageSize={2} />
        </Box>
      </Box>
    </>
  );
}
